export const IllustNoWifi = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='119' height='106' viewBox='0 0 119 106' fill='none'>
    <path
      d='M92.2048 55.4039C94.4386 53.1623 94.4556 49.4955 91.9953 47.5071C82.6143 39.9314 70.9398 35.8018 58.9044 35.8018C46.869 35.8018 35.1945 39.9314 25.8135 47.5071C23.3504 49.4984 23.3702 53.1623 25.6012 55.4039C27.8321 57.6455 31.4362 57.6114 33.9531 55.6884C41.1375 50.2323 49.8973 47.2803 58.903 47.2803C67.9086 47.2803 76.6685 50.2323 83.8528 55.6884C86.3726 57.6114 89.9738 57.6484 92.2048 55.4039Z'
      fill='#DDDDDD'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M106.219 29.36C108.524 31.3512 108.512 34.8815 106.361 37.0406C104.214 39.1997 100.743 39.1769 98.4134 37.2198C87.3312 27.9136 73.3472 22.8152 58.9042 22.8152C44.4611 22.8152 30.4771 27.9136 19.3949 37.2198C17.062 39.1769 13.5938 39.2139 11.445 37.0406C9.2961 34.8672 9.28195 31.3512 11.5894 29.36C24.7588 17.9955 41.5443 11.7471 58.9042 11.7471C76.264 11.7471 93.0495 17.9955 106.219 29.36ZM92.2044 55.4038C94.4382 53.1622 94.4552 49.4954 91.9949 47.507C82.6139 39.9313 70.9394 35.8016 58.904 35.8016C46.8686 35.8016 35.194 39.9313 25.8131 47.507C23.3499 49.4983 23.3698 53.1622 25.6007 55.4038C27.8317 57.6454 31.4358 57.6113 33.9527 55.6883C41.1371 50.2322 49.8969 47.2801 58.9026 47.2801C67.9082 47.2801 76.668 50.2322 83.8524 55.6883C86.3722 57.6113 89.9734 57.6482 92.2044 55.4038ZM76.2078 64.7609C78.8323 66.3852 79.0418 69.9752 77.009 72.2993C74.9734 74.6262 71.4627 74.777 68.7136 73.386C65.7352 71.8842 62.4546 71.0863 59.1223 71.0533C55.7901 71.0202 52.4944 71.7529 49.487 73.1954C46.7068 74.5295 43.2018 74.3105 41.2143 71.9437C39.2268 69.577 39.5071 65.9927 42.1628 64.4224C47.3328 61.3662 53.2339 59.7829 59.2321 59.8425C65.2302 59.9022 71.0989 61.6025 76.2078 64.7609ZM68.1649 90.0315C68.1649 94.9478 64.0179 98.9333 58.9023 98.9333C53.7868 98.9333 49.6398 94.9478 49.6398 90.0315C49.6398 85.1151 53.7868 81.1297 58.9023 81.1297C64.0179 81.1297 68.1649 85.1151 68.1649 90.0315Z'
      fill='url(#paint0_linear_2065_19312)'
    />
    <path
      d='M106.36 37.0406C108.512 34.8815 108.524 31.3512 106.219 29.36C93.0495 17.9955 76.264 11.7471 58.9041 11.7471C41.5443 11.7471 24.7588 17.9955 11.5894 29.36C9.28195 31.3512 9.2961 34.8672 11.445 37.0406C13.5938 39.2139 17.062 39.1769 19.3949 37.2198C30.4771 27.9136 44.4611 22.8152 58.9041 22.8152C73.3472 22.8152 87.3312 27.9136 98.4134 37.2198C100.743 39.1769 104.214 39.1997 106.36 37.0406Z'
      fill='url(#paint1_linear_2065_19312)'
    />
    <path
      d='M77.0092 72.2992C79.042 69.9751 78.8324 66.3852 76.2079 64.7609C71.0991 61.6024 65.2304 59.9021 59.2322 59.8424C53.234 59.7828 47.333 61.3661 42.1629 64.4223C39.5073 65.9926 39.227 69.5769 41.2145 71.9436C43.202 74.3104 46.707 74.5294 49.4872 73.1953C52.4945 71.7529 55.7902 71.0202 59.1225 71.0532C62.4547 71.0862 65.7354 71.8841 68.7138 73.3859C71.4629 74.7769 74.9735 74.6262 77.0092 72.2992Z'
      fill='url(#paint2_linear_2065_19312)'
    />
    <path
      opacity='0.55'
      d='M92.2048 55.4039C94.4386 53.1623 94.4556 49.4955 91.9953 47.5071C82.6143 39.9314 70.9398 35.8018 58.9044 35.8018C46.869 35.8018 35.1945 39.9314 25.8135 47.5071C23.3504 49.4984 23.3702 53.1623 25.6012 55.4039C27.8321 57.6455 31.4362 57.6114 33.9531 55.6884C41.1375 50.2323 49.8973 47.2803 58.903 47.2803C67.9086 47.2803 76.6685 50.2323 83.8528 55.6884C86.3726 57.6114 89.9738 57.6484 92.2048 55.4039Z'
      fill='url(#paint3_linear_2065_19312)'
      fill-opacity='0.65'
    />
    <path
      d='M103.656 43.6045C111.261 43.6045 117.427 37.4392 117.427 29.834C117.427 22.2287 111.261 16.0635 103.656 16.0635C96.051 16.0635 89.8857 22.2287 89.8857 29.834C89.8857 37.4392 96.051 43.6045 103.656 43.6045Z'
      fill='#666666'
    />
    <path
      d='M109.344 33.9021L105.265 29.8342L109.344 25.7662C109.56 25.5513 109.681 25.2597 109.681 24.9557C109.681 24.6518 109.56 24.3602 109.344 24.1453C109.238 24.0388 109.111 23.9544 108.972 23.8968C108.832 23.8392 108.683 23.8096 108.532 23.8096C108.227 23.8096 107.935 23.9303 107.719 24.1453L103.64 28.2132L99.5613 24.1453C99.3427 23.9455 99.0552 23.8375 98.7588 23.8438C98.4623 23.8501 98.1798 23.9702 97.9699 24.1791C97.76 24.388 97.639 24.6696 97.6321 24.9653C97.6253 25.2609 97.733 25.5478 97.9329 25.7662L102.012 29.8342L97.9329 33.9021C97.733 34.1205 97.6253 34.4074 97.6321 34.7031C97.639 34.9987 97.76 35.2803 97.9699 35.4892C98.1798 35.6981 98.4623 35.8182 98.7588 35.8245C99.0552 35.8308 99.3427 35.7228 99.5613 35.523L103.64 31.4551L107.719 35.523C107.935 35.738 108.227 35.8588 108.532 35.8588C108.837 35.8588 109.129 35.738 109.344 35.523C109.56 35.3081 109.681 35.0166 109.681 34.7126C109.681 34.4086 109.56 34.1171 109.344 33.9021Z'
      fill='white'
    />
    <defs>
      <linearGradient
        id='paint0_linear_2065_19312'
        x1='58.9034'
        y1='11.7599'
        x2='58.9034'
        y2='192.535'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#C8C8C8' />
        <stop offset='0.71875' stop-color='#DCDCDC' />
        <stop offset='1' stop-color='#DDDDDD' stop-opacity='0' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_2065_19312'
        x1='110.018'
        y1='36.4111'
        x2='9.89824'
        y2='0.851604'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#BDBDBD' />
        <stop offset='1' stop-color='#DDDDDD' stop-opacity='0' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_2065_19312'
        x1='100.644'
        y1='82.7727'
        x2='40.0015'
        y2='59.4485'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0.492883' stop-color='#CCCCCC' />
        <stop offset='1' stop-color='#DDDDDD' stop-opacity='0' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_2065_19312'
        x1='87.7348'
        y1='51.1394'
        x2='28.3091'
        y2='42.3774'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#CCCCCC' />
        <stop offset='1' stop-color='#B7B7B7' stop-opacity='0' />
      </linearGradient>
    </defs>
  </svg>
);
